export default "__VITE_ASSET__BRG1phCI__"